import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { InvoiceDetailService } from "./invoice-detail.service";
import { BehaviorSubject, catchError, finalize, forkJoin, Observable, of, Subject, switchMap, take, takeUntil, tap } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { CommonService } from "src/app/shared/services/common.service";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from "src/app/shared/components/dialog/dialog.component";
import { ModalDialogData } from "src/app/models/modelDialog.model";
import { environment } from "src/environments/environment";
import { FormControl, NgForm } from "@angular/forms";
import { UserService } from '../../../core/services/user.service';
import { TransactionAttachmentPopupComponent } from "./transaction-attachment-popup/transaction-attachment-popup.component";
import { reindexMap, taxType } from "src/app/core/constants/constants.items";
import { BankAccountResponse, CategoryResponse, InvoiceCategorization, InvoiceDetails, Transaction } from "./invoice.interface";

interface LineItem {
    id: string;
    description: string;
    quantity: number;
    unit_price: number;
    amount: number;
    tax_rate?: number;
    tax_amount?: number;
    total_amount: number;
}

interface Payments {
    id: string;
    reference: string;
    paidAt: string;
    amount: string;
    status: string;
}
interface Categorization {
    id: string;
    category: string;
    taxrate: string;
    amount: string;
}

export const MY_DATE_FORMATS = {
    parse: {
      dateInput: 'DD MMM, YYYY',
    },
    display: {
      dateInput: 'DD MMM, YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };

interface CategoryItem {
  id: string;
  name: string;
  type: string;
}

interface GroupedCategory {
  type: string;
  items: CategoryItem[];
}

@Component({
    selector: 'app-invoice-detail',
    templateUrl: './invoice-detail.component.html',
    styleUrls: ['./invoice-detail.component.scss'],
    providers: [{provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS}],
})
export class InvoiceDetailComponent implements OnDestroy, OnInit {

    private destroy$: Subject<void> = new Subject<void>();
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private editModeSubject = new BehaviorSubject<boolean>(false);
    private mainLoader = new BehaviorSubject<boolean>(false);
    private isItemsDirtySubject = new BehaviorSubject<boolean>(false);
    private isInvoceDirtySubject = new BehaviorSubject<boolean>(false);
    private showQrCodeSubject = new BehaviorSubject<boolean>(false);
    private showPaymentInputSubject = new BehaviorSubject<boolean>(false);

    showQrCode$ = this.showQrCodeSubject.asObservable();
    mainLoader$ = this.mainLoader.asObservable();
    loading$ = this.loadingSubject.asObservable();
    editMode$ = this.editModeSubject.asObservable();
    error: string | null = null;
    showPaymentInput$ = this.showPaymentInputSubject.asObservable();

    vehicleId: string;
    entityId: string;
    isQrCodeReadOnly = false;
    selectedInvoice: any | null = null;
    selectedVehicle: any | null = null;
    counterPartyName = ""; // Removed redundant type annotation
    editInvoiceDetails: any = {};
    // editInvoiceLineItems: any = {};
    editBankAccount: any = {};
    lineItemsColumns: string[] = ["Item name", "Quantity", "Price", "Total", "Tax"];
    lineItemDataSource: MatTableDataSource<LineItem>;
    paymentsDataSource: MatTableDataSource<Payments>;
    categorizationDataSource: MatTableDataSource<Categorization>;
    counterpartsList: any[] = [];
    counterpartAddressMap: any = {};
    selectedCounterpart: any = null;
    counterpartBankAccounts: any[] = [];
    selectedBankAccount: any = null;
    selectedBankAccountName: any = null;
    bankAccount: any = null;
    qrCodeData: any = null;
    invoiceLogsData: any = [];
    commentControl = new FormControl();
    saveCommentLoading = false;
    commentLoading = false;
    commentList: any = [];
    invoiceId: string;
    userName: string;
    totalItems = 0;
    page = 1;
    pageSize = 10;
    scrollCommnetLoading = false;
    isLinkedTransaction: boolean = false;
    initialLinkedtransactions: Transaction[] = [];
    invoiceHistoryOperationType = [
        { action: 'CREATE', updatedNameLabel: 'Added by', updatedDateLabel: 'Added on' },
        { action: 'UPDATE', updatedNameLabel: 'Updated by', updatedDateLabel: 'Last updated on' },
        { action: 'DELETE', updatedNameLabel: 'Deleted by', updatedDateLabel: 'Deleted on' },
        { action: 'SUBMITTED_FOR_APPROVAL', updatedNameLabel: 'Submitted for approval by', updatedDateLabel: 'Submitted on' },
        { action: 'APPROVED', updatedNameLabel: 'Approved by', updatedDateLabel: 'Approved on' },
        { action: 'REJECTED', updatedNameLabel: 'Rejected by', updatedDateLabel: 'Rejected on' },
        { action: 'PAID', updatedNameLabel: 'Paid by', updatedDateLabel: 'Paid on' },
        { action: 'PARTIALLY_PAID', updatedNameLabel: 'Partially paid by', updatedDateLabel: 'Partially paid on' },
    ];
    @ViewChild('editInvoice') editInvoice!: NgForm;
    id: string;
    taxType = taxType
    cateoryLists: any = [];
    rawCategories: CategoryItem[] = [];
    editCategorizationItem: any = [];
    panelOpenState = false;
    showSplitedCategorization = false;
    invoiceCategorizations: any = [];
    linkedTransationLists: any = [];
    filteredCategories: GroupedCategory[] = [];
    filteredCategoriesMap: { [key: number]: GroupedCategory[] } = {};
    searchQueries: { [key: number]: string } = {};


    constructor(
        private invoiceDetailService: InvoiceDetailService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public commonService: CommonService,
        public dialog: MatDialog,
        private userService: UserService,
    ) {
        this.lineItemDataSource = new MatTableDataSource<LineItem>([]);
        this.paymentsDataSource = new MatTableDataSource<Payments>([]);
        this.categorizationDataSource = new MatTableDataSource<Categorization>([]);
    }
    ngOnDestroy(): void {
        this.commonService.onPopState();
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        const { id, name } = this.commonService.getUserParseConfigData();
        this.userName = this.commonService.removeSpace(name);
        this.activatedRoute.params.pipe(takeUntil(this.destroy$), tap(params => {
            const urlSegments = this.router.url.split('/');
            urlSegments.forEach((segment, index) => {
                if (segment === 'vehicle' && urlSegments[index + 1]) {
                    this.vehicleId = urlSegments[index + 1];
                }
                if (segment === 'gp' && urlSegments[index + 1]) {
                    this.entityId = urlSegments[index + 1];
                }
            });
            console.info('VehicleId:', this.vehicleId, 'EntityId:', this.entityId);
            if (this.vehicleId && this.entityId) {
                this.initializeData();
            }
        })).subscribe()

    }
 
    onSearchChange(index: number, search: string): void {
        console.log('search', search)
        const trimmedSearch = search?.trim().toLowerCase();
        if (!trimmedSearch) {
          this.filteredCategoriesMap[index] = [...this.cateoryLists];
          return;
        }
      
        this.filteredCategoriesMap[index] = this.cateoryLists
          .map((group: GroupedCategory) => {
            const filteredItems = group.items.filter((item: CategoryItem) =>
              item.name.toLowerCase().includes(trimmedSearch) ||
              item.type.toLowerCase().includes(trimmedSearch) ||
              group.type.toLowerCase().includes(trimmedSearch)
            );
            return { ...group, items: filteredItems };
          })
          .filter((group: GroupedCategory) => group.items.length > 0);
    }
    clearSearch(index: number) {
        this.searchQueries[index] = '';
        this.filteredCategoriesMap[index] = [...this.cateoryLists];
    }
 
    groupAndSortCategories(data: CategoryItem[]): GroupedCategory[] {
        const grouped: { [key: string]: CategoryItem[] } = {};      
        for (const item of data) {
          if (!grouped[item.type]) {
            grouped[item.type] = [];
          }
          grouped[item.type].push(item);
        }
        return Object.keys(grouped).map(type => ({
          type,
          items: grouped[type].sort((a, b) => a.name.localeCompare(b.name))
        })).sort((a, b) => a.type.localeCompare(b.type));
    } 

    private callApiForInvoiceDetails(formEditModestatus = true): void {
        this.invoiceDetailService.invoiceDetailsAsObservables$.pipe(
            takeUntil(this.destroy$),
            take(1),
            switchMap(invoiceDetails => {
                if (!invoiceDetails) {
                    this.error = 'No invoice details found';
                    return of(null);
                }
                this.selectedInvoice = invoiceDetails;
                if (['draft'].includes(invoiceDetails?.status) && formEditModestatus) {
                    this.editModeSubject.next(true);
                }
                //prepare api calls

                const apiV2Calls: {category: Observable<CategoryResponse | null>, invoice: Observable<InvoiceDetails | null> } = {
                    category: this.invoiceDetailService.getInvoiceCategoryList().pipe(catchError(() => of(null))),
                    invoice: this.invoiceDetailService.getInvoiceDetails(this.vehicleId, invoiceDetails.id).pipe(catchError(() => of(null)))
                }

                return forkJoin(apiV2Calls);

            }),
            catchError((error) => {
                this.error = 'Failed to load invoice details. Please try again.';
                console.error('Error loading invoice details:', error);
                return of(null);
            }),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe((results) => {
            if (!results) return;
            this.selectedInvoice = results.invoice;
            this.rawCategories = results.category?.data ?? [];
            this.cateoryLists = this.groupAndSortCategories(this.rawCategories);
            this.filteredCategories = [...this.cateoryLists];
            this.linkedTransationLists = results.invoice?.transactions || [];
            if (results.invoice) {
                this.invoiceCategorizations = results.invoice?.invoiceCategorizations;
                this.categorizationDataSource.data = this.invoiceCategorizations;
                this.counterPartyName = results.invoice?.counterparty?.name || results.invoice.rawData?.["VendorAddressRecipient"];
                this.selectedBankAccountName = results.invoice?.bankAccount?.account_holder_name || results.invoice?.bankAccount?.iban || results.invoice.rawData?.["VendorAddressRecipient"];
                const payments: Payments[] = results.invoice?.payments as Payments[];
                
                this.bankAccount = results.invoice?.bankAccount;
                this.paymentsDataSource.data = payments.map((p)=>{
                    p.status = "Paid";
                    p.paidAt = this.commonService.getDateFormatWithTime(p.paidAt, true);
                    return p;
                });
            }

            const bankAccountFromOcr = this.selectedInvoice.rawData?.["PaymentDetails"]?.pop();
            if(bankAccountFromOcr){
                this.bankAccount = {
                    name: this.selectedBankAccountName,
                    iban: bankAccountFromOcr?.["IBAN"],
                    bic: bankAccountFromOcr?.["BIC"] || bankAccountFromOcr?.["SWIFT"],
                }
            }
            else {
                this.bankAccount = this.counterpartBankAccounts.find((account: any) => account.id === this.selectedInvoice.bankAccountId);    
            }
           
            if (['draft'].includes(this.selectedInvoice?.status) && formEditModestatus) {
                this.toggleEditMode(true);
            }
            this.invoiceLogsData = results.invoice?.history ?? [];
            this.loadingSubject.next(false);
        })
    }

    private initializeData(): void {
        if (!this.vehicleId || !this.entityId) {
            console.warn('VehicleId or EntityId is missing');
            return;
        }

        this.loadingSubject.next(true);

        this.callApiForInvoiceDetails();

        this.invoiceDetailService.selectedVehicleAsObservables$.pipe(
            takeUntil(this.destroy$),
        ).subscribe((vehicle) => {
            this.selectedVehicle = vehicle;
        });
        this.invoiceDetailService.invoiceDetailsAsObservables$.pipe(takeUntil(this.destroy$))
            .subscribe((invoiceDetails) => {
                if (invoiceDetails && invoiceDetails.id) {
                    this.invoiceId = invoiceDetails.id;
                    this.getCommentListByInvoiceId();
                }
            });
    }

    closeInvoiceDetailDrawer(): void {
        this.invoiceDetailService.closeInvoiceDetailDrawer();
    }

    closeQrCode(): void {
        this.showQrCodeSubject.next(false);
        this.qrCodeData = null;
        this.isQrCodeReadOnly = false;
    }
    markAsPaid(): void {
        this.mainLoader.next(true);
        this.showQrCodeSubject.next(false);

        this.invoiceDetailService.updatePayableStatusToPaid(this.vehicleId, this.selectedInvoice.id, this.qrCodeData?.embeddedMetaData).pipe(
            takeUntil(this.destroy$),
            tap((response) => {
                const invoiceResponse =JSON.parse(JSON.stringify(response));
                this.invoiceDetailService.invoiceDetails.next(invoiceResponse.data);
                this.mainLoader.next(false);
                this.commonService.successNotification('Invoice marked as paid successfully');
            }),
            catchError((error) => {
                console.error('Error marking invoice as paid:', error);
                this.commonService.errorNotification('Failed to mark invoice as paid. Please try again.');
                this.mainLoader.next(false);
                return of(null);
            })
        ).subscribe(() => {


            this.qrCodeData = null;
            this.isQrCodeReadOnly = false;
            this.loadingSubject.next(true);
            this.callApiForInvoiceDetails(false);


            
        });
    }

    private dateConversion(date: string, time = false): string {
        if(time){
            
            return new Date(date).toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'short', 
                day: '2-digit', 
                hour: '2-digit', 
                minute: '2-digit',
                hour12: true 
            }).replace(',', '').replace(/(\d+)\s+(\w+)\s+(\d+)/, '$1 $2, $3');
        }
        return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
    }
    // confirmation popup
    onSaveConfirmation(): void {
        if (this.ErrorValidationMessage() !== true) {
            return;
       }
        const dialogRef = this.dialog.open(DialogComponent, {
            data: <ModalDialogData>{
                titleKey: 'Review all fields before saving?',
                contentKey: 'Have you verified that all extracted data is correct?',
                positiveMessageKey: 'Save Anyway',
                negativeMessageKey: 'Back to Editing',
                isValid: '3',
            },
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe((res) => {
            if (res == 1) {
                this.onSaveInvoice();
            }
        });
    }

    ErrorValidationMessage() {
        if(!this.editInvoiceDetails.invoiceNumber){
            this.commonService.errorNotification('Invoice number is required');
            return;
        }

        if(!this.editInvoiceDetails.servicePeriodEnd || !this.editInvoiceDetails.servicePeriodEnd){
            this.commonService.errorNotification('Service Period is required');
            return;
        }

        if(!this.editCategorizationItem.length){
            this.commonService.errorNotification('At least one category item is required');
            return;
        }

        const invalidCategories = this.editCategorizationItem.filter((item: any) => !item.category || !item.category.id);
        if (invalidCategories.length > 0) {
            this.commonService.errorNotification('Please select a category for all category items');
            return;
        }

        if(!this.editInvoiceDetails.currency){
            this.commonService.errorNotification('Invoice type is required');
            return;
        }

        if(!this.editBankAccount.name){
            this.commonService.errorNotification('Account holder name is required');
            return;
        }
        if(!this.editBankAccount.iban){
            this.commonService.errorNotification('IBAN is required');
            return;
        }

        if(!this.editBankAccount.bic){
            this.commonService.errorNotification('BIC is required');
            return;
        }
        return true;
    }

    onSaveInvoice(): void {
        if (this.ErrorValidationMessage() !== true) {
            return;
       }
        if(!this.editInvoiceDetails.invoiceNumber){
            this.commonService.errorNotification('Invoice number is required');
            return;
        }

        if(!this.editInvoiceDetails.servicePeriodEnd || !this.editInvoiceDetails.servicePeriodEnd){
            this.commonService.errorNotification('Service Period is required');
            return;
        }

        if(!this.editCategorizationItem.length){
            this.commonService.errorNotification('At least one category item is required');
            return;
        }

        const invalidCategories = this.editCategorizationItem.filter((item: any) => !item.category || !item.category.id);
        if (invalidCategories.length > 0) {
            this.commonService.errorNotification('Please select a category for all category items');
            return;
        }

        if(!this.editInvoiceDetails.currency){
            this.commonService.errorNotification('Invoice type is required');
            return;
        }

        if(!this.editBankAccount.name){
            this.commonService.errorNotification('Account holder name is required');
            return;
        }
        if(!this.editBankAccount.iban){
            this.commonService.errorNotification('IBAN is required');
            return;
        }

        if(!this.editBankAccount.bic){
            this.commonService.errorNotification('BIC is required');
            return;
        }
        this.mainLoader.next(true);
        this.isInvoceDirtySubject.next(false);
        this.isItemsDirtySubject.next(false);
        this.editInvoiceDetails.bankAccountId = this.selectedBankAccount;
        this.editInvoiceDetails.counterpartAddressId = this.counterpartAddressMap[this.selectedCounterpart]?.addressId;


        const forSave = {
            ...this.editInvoiceDetails,
            bankAccount: {
                account_holder_name: this.editBankAccount.name,
                iban: this.editBankAccount.iban,
                bic: this.editBankAccount.bic,
            },
            counterparty: {
                name: this.counterPartyName,
                id: this.selectedCounterpart,
            },

            invoiceCategorizations: this.editCategorizationItem.map((item: InvoiceCategorization) => ({
                categoryId: this.getCateroryID(item.category),
                taxValue: Number(item.taxValue) || 0,
                amount: item.amount,
            }))
        }
        forSave.issueDate = this.editInvoiceDetails.issueDate ? this.dateConversion(this.editInvoiceDetails.issueDate) : null;
        forSave.dueDate = this.editInvoiceDetails.dueDate ? this.dateConversion(this.editInvoiceDetails.dueDate) : null;
        forSave.servicePeriodStart = this.editInvoiceDetails.servicePeriodStart ? this.editInvoiceDetails.servicePeriodStart.format('YYYY-MM-DD') : null;
        forSave.servicePeriodEnd = this.editInvoiceDetails.servicePeriodEnd ? this.editInvoiceDetails.servicePeriodEnd.format('YYYY-MM-DD') : null;
        delete forSave.categoryAmountDifference;
        delete forSave.totalCategoryAmount;
        const saveAPICalls: {  updateInvoice: Observable<any> } = {

            updateInvoice: this.invoiceDetailService.updateInvoiceDetails(this.vehicleId, this.selectedInvoice.id, forSave)


        }
        forkJoin(saveAPICalls).pipe(
            takeUntil(this.destroy$),
            tap(() => {
                this.commonService.successNotification('Invoice updated successfully');
                this.mainLoader.next(false);
                this.loadingSubject.next(true);
                this.editModeSubject.next(false);
                this.isLinkedTransaction = false;
            }),
            catchError((error) => {
                console.error('Error updating invoice:', error);    
                this.commonService.errorNotification('Failed to update invoice. Please try again.');
                this.mainLoader.next(false);
                this.isInvoceDirtySubject.next(false);
                this.isItemsDirtySubject.next(false);
                return of(null);
            })
        ).subscribe((results) => {
            this.selectedInvoice = { ...this.selectedInvoice, ...this.editInvoiceDetails };
            this.invoiceDetailService.invoiceDetails.next(this.selectedInvoice);
            if (results) {
                this.callApiForInvoiceDetails(false);
            }
        });
    }

     toggleEditMode(formEditModestatus : boolean) {
       this.editModeSubject.next(formEditModestatus);
        if (this.editModeSubject.value) {
            this.editInvoiceDetails = { ...this.selectedInvoice };

            this.editBankAccount = {...this.bankAccount};
            this.editCategorizationItem = this.invoiceCategorizations.map((item: InvoiceCategorization) => ({
                category: this.getCateroryDetails(item.category),
                taxValue: Number(item.taxValue),
                amount: item.totalAmount,
            }));
            // getting each category dropdown list value
            this.invoiceCategorizations.forEach((item: InvoiceCategorization, i: number) => {
                this.filteredCategoriesMap[i] = [...this.cateoryLists];
                this.searchQueries[i] = '';
            });

            this.onCategoryItemChange();
            this.showSplitedCategorization = false;
            this.selectedCounterpart = this.editInvoiceDetails.counterpartyId;
            this.selectedBankAccount = this.editInvoiceDetails.bankAccountId;
            this.loadingSubject.next(true);
            this.invoiceDetailService.getAllCounterParts(this.vehicleId).pipe(
                takeUntil(this.destroy$),
                tap((counterParts: any) => {
                    if (counterParts && counterParts.data) {
                        this.counterpartsList = counterParts.data.map((counterPart: any) => {
                            return {
                                value: counterPart.id,
                                label: counterPart.name,
                                selected: this.selectedInvoice.counterpartyId === counterPart.id,
                            }
                        });
                    }
                }
                ),
                catchError((error) => {
                    console.error('Error fetching counterparts:', error);
                    this.commonService.errorNotification('Failed to fetch counterparts. Please try again.');
                    this.loadingSubject.next(false);
                    return of(null);
                }
                )
            ).subscribe(
                () => {
                    this.loadingSubject.next(false);
                    this.selectedInvoice = { ...this.selectedInvoice, ...this.editInvoiceDetails };
                }
            );
            
        }
        else {
            this.editInvoiceDetails = {};
            this.editCategorizationItem = [];
            this.editBankAccount = {};
            this.selectedCounterpart = null;
            this.counterpartBankAccounts = [];
            this.loadingSubject.next(true);
            if (this.isLinkedTransaction && this.initialLinkedtransactions.length > 0) {
                const ids = this.initialLinkedtransactions.map(item => item.transactionId);
                this.callUnlinkedTransaction(ids);
            } else {
                this.callApiForInvoiceDetails(false);
            }
        }

        
     }
     callUnlinkedTransaction(ids: string[]) {
        this.loadingSubject.next(true);
        const params: any = {};
        params.transactionIds = ids;
        this.invoiceDetailService.unlinkInvoiceToTransaction(this.invoiceId, params).pipe(
            takeUntil(this.destroy$),
            tap(() => {
                this.callApiForInvoiceDetails(false);
            }),
            catchError((error) => {
                this.loadingSubject.next(false);
                return of(null);
            })
        ).subscribe();
    }

    handleApproveInProgress(): void {
        if(!this.bankAccount){
            this.commonService.errorNotification('Please select a bank account before approving the invoice.');
            return;
        }

        if(this.bankAccount?.name === null || this.bankAccount?.name === "") {
            this.commonService.errorNotification('Please add the account holder name before submitting the invoice.');
            return;
        }


        if(this.bankAccount?.iban === null || this.bankAccount?.iban === "") {
            this.commonService.errorNotification('Please add the IBAN before submitting the invoice.');
            return;
        }

        if (this.selectedInvoice.counterpartyId
            && this.selectedInvoice.counterpartyId
            && (this.selectedInvoice.bankAccount.account_holder_name === null || this.selectedInvoice.bankAccount.account_holder_name === "")) {
            this.commonService.errorNotification('Please add the account holder name before submitting the invoice.');
            return;
        }
        if(this.selectedInvoice.bankAccountId === null ||
         this.selectedInvoice.bankAccountId === undefined) {

            this.commonService.errorNotification('Please select a bank account before approving the invoice.');
            return;
        }
        this.mainLoader.next(true);

        this.invoiceDetailService.updatePayableStatusToApproveInProgress(this.vehicleId, this.selectedInvoice.id).pipe(
            takeUntil(this.destroy$),
            tap(() => {
                 this.mainLoader.next(false);
                 this.loadingSubject.next(true);
                 this.callApiForInvoiceDetails(false);
            }),
            catchError((error) => {
                console.error('Error approving invoice:', error);
                this.commonService.errorNotification('Failed to approve invoice. Please try again.');
                this.mainLoader.next(false);
                return of(null);
            })
        ).subscribe();
    }

    handleCancelInvoice(): void {
        this.mainLoader.next(true);
        this.invoiceDetailService.updatePyableStatusToCancelled(this.vehicleId, this.selectedInvoice.id).pipe(
            takeUntil(this.destroy$),
            tap(() => { 
                this.mainLoader.next(false);
                this.loadingSubject.next(true);
                this.callApiForInvoiceDetails(false);
            }),
            catchError((error) => {
                console.error('Error cancelling invoice:', error);
                this.commonService.errorNotification('Failed to cancel invoice. Please try again.');
                this.mainLoader.next(false);
                return of(null);
            })
        ).subscribe();
    }

    onBankAccountChange(value: any): void {
       this.editBankAccount = this.counterpartBankAccounts.find((account: any) => account.id === value);
    }

    onCounterpartyChange(value: any): void {
        
        this.editBankAccount = {};
        this.loadingSubject.next(true);
        this.invoiceDetailService.getAllBankAccountsForCounterPart(this.vehicleId, value).pipe(
            takeUntil(this.destroy$),
            tap((bankAccounts: any) => {
                if (bankAccounts && bankAccounts.data) {
                    this.counterpartBankAccounts = bankAccounts.data.map((account: any) => ({
                        id: account.id,
                        name: account.account_holder_name,
                        iban: account.iban,
                        bic: account.bic
                    }));
                }

                this.loadingSubject.next(false);
            }
            ),
            catchError((error) => {
                console.error('Error fetching bank accounts:', error);
                this.commonService.errorNotification('Failed to fetch bank accounts. Please try again.');
                this.loadingSubject.next(false);
                return of(null);
                
            }
            )
        ).subscribe(() => {
            this.loadingSubject.next(false);
        }
        );
    }


    handleShowInvoicePayment(id: string) {
        this.mainLoader.next(true);
        this.invoiceDetailService.viewPaymentCode(this.vehicleId, id).pipe(
            takeUntil(this.destroy$),
            tap((response: any) => {
                this.mainLoader.next(false);
                this.showQrCodeSubject.next(true);
                this.qrCodeData = response;
                this.isQrCodeReadOnly = true;
            }),
            catchError((error) => {
                this.commonService.errorNotification('Failed to view payment code. Please try again.');
                this.mainLoader.next(false);
                return of(null);
            })
        ).subscribe();
    }

    handlePayInvoice(): void {
        this.showPaymentInputSubject.next(true);
    }

    closePaymentInput(): void {
        this.showPaymentInputSubject.next(false);
    }

    handlePaymentProceed(paymentData: any): void {
        this.showPaymentInputSubject.next(false);
        this.mainLoader.next(true);
        
        // Generate payment code with the specified amount
        this.invoiceDetailService.generatePaymentCode(this.vehicleId, this.selectedInvoice.id, paymentData.amount).pipe(
            takeUntil(this.destroy$),
            tap((response: any) => {
                if (response) {
                    this.qrCodeData = response;
                    this.showQrCodeSubject.next(true);
                    this.isQrCodeReadOnly = false;
                } else {
                    this.commonService.errorNotification('Failed to generate QR code. Please try again.');
                }
                this.mainLoader.next(false);
            }),
            catchError((error) => {
                console.error('Error generating QR code:', error);
                this.commonService.errorNotification(error.error.message || 'Failed to generate QR code. Please try again.');
                this.mainLoader.next(false);
                return of(null);
            })
        ).subscribe();
    }

    handleReopenInvoice(): void {
        this.mainLoader.next(true);
        this.invoiceDetailService.updatePayableStatusToReopened(this.vehicleId, this.selectedInvoice.id).pipe(
            takeUntil(this.destroy$),
            tap(() => { this.selectedInvoice.status = 'new'; this.mainLoader.next(false); }),
            catchError((error) => {
                console.error('Error reopening invoice:', error);
                this.commonService.errorNotification('Failed to reopen invoice. Please try again.');
                this.mainLoader.next(false);
                return of(null);
            })
        ).subscribe();
    }

    handleRejectInvoice(): void {
        this.mainLoader.next(true);
        this.invoiceDetailService.updatePayableStatusToRejected(this.vehicleId, this.selectedInvoice.id).pipe(
            takeUntil(this.destroy$),
            tap(() => {
                this.selectedInvoice.status = 'rejected';
                this.mainLoader.next(false);
                this.loadingSubject.next(true);
                this.callApiForInvoiceDetails(false);
            }),
            catchError((error) => {
                console.error('Error rejecting invoice:', error);
                this.commonService.errorNotification('Failed to reject invoice. Please try again.');
                this.mainLoader.next(false);
                return of(null);
            })
        ).subscribe();
    }

    handleApproveInvoice(): void {
        this.mainLoader.next(true);
        this.invoiceDetailService.updatePayableStatusToApproved(this.vehicleId, this.selectedInvoice.id).pipe(
            takeUntil(this.destroy$),
            tap(() => {
                this.selectedInvoice.status = 'ready_for_payment';
                this.mainLoader.next(false);
                this.loadingSubject.next(true);
                this.callApiForInvoiceDetails(false);
            }),
            catchError((error) => {
                console.error('Error approving invoice:', error);
                this.commonService.errorNotification('Failed to approve invoice. Please try again.');
                this.mainLoader.next(false);
                return of(null);
            })
        ).subscribe();
    }

    deleteDialog() {
        const dialogRef = this.dialog.open(DialogComponent, {
          data: <ModalDialogData>{
            titleKey: 'Delete invoice ?',
            contentKey: 'Are you sure you want to delete? This will remove all the data including the documents.',
            positiveMessageKey: 'Delete',
            negativeMessageKey: 'Cancel',
            isValid: '2',
          },
          disableClose: false,
        });
        dialogRef.afterClosed().subscribe(result => {
            if(result == 1) {
                this.invoiceDetailService.deleteInvoice(this.vehicleId, this.selectedInvoice.id).pipe(
                    takeUntil(this.destroy$),
                    tap(() => {

                        this.commonService.successNotification('1 invoice has been deleted');
                        this.invoiceDetailService.emitValueDeleted();
                        this.closeInvoiceDetailDrawer();
                    }),
                    catchError((error) => {
                        this.commonService.errorNotification('Failed to delete invoice.');
                        return of(null);
                    })
                ).subscribe();
            }
        });
      }
    getDocumentUrl(): string {
        if (!this.selectedInvoice?.documentUrl) return '';
        return this.selectedInvoice.documentUrl.startsWith('http') 
            ? this.selectedInvoice.documentUrl 
            : `${environment.presignedDomainUrl}${this.selectedInvoice.documentUrl}`;
    }

    getformatedDate(updatedDate: string): string {
        if (!updatedDate) {
            return '';
        }
        const options: any = {
            year: '2-digit',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        };
        const formatted = new Date(updatedDate).toLocaleString('en-US', options);
        return formatted;
    }
    cancelCommentForm() {
        this.commentControl.reset();
    }

    saveCommentForm() {
        this.saveCommentLoading = true;
        this.invoiceDetailService.saveCommentsData(this.invoiceId, { commentText: this.commentControl.value })
            .pipe(takeUntil(this.destroy$)).subscribe({
                next: (data: any) => {
                    if (data) {
                        this.page = 1;
                        this.commentList = [];
                        this.getCommentListByInvoiceId();
                    }
                },
                error: (error) => {
                    this.saveCommentLoading = false;
                },
                complete: () => {
                    this.saveCommentLoading = false;
                    this.commentControl.reset();
                },
            });
    }

    getCommentListByInvoiceId(scrollLoading = false) {
        if (!scrollLoading) {
            this.commentLoading = true;
        } else {
            this.scrollCommnetLoading = true;
        }
        this.invoiceDetailService.getCommentsData(this.invoiceId, this.page, this.pageSize)
            .pipe(takeUntil(this.destroy$)).subscribe({
                next: (data: any) => {
                    this.commentList = data.data ? [...this.commentList, ...data.data] : [];
                    this.totalItems = data.totalCount;
                    this.page++;
                },
                error: (error) => {
                    this.commentLoading = false;
                    this.scrollCommnetLoading = false;
                },
                complete: () => {
                    this.commentLoading = false;
                    this.scrollCommnetLoading = false;
                },
            });
    }
    
    getLabelsByAction(action: string): { action: string, updatedNameLabel: string, updatedDateLabel: string } {
        if (!action) {
            return { action: '-', updatedNameLabel: '-', updatedDateLabel: '-' };
        }
        return this.invoiceHistoryOperationType.find(item => item.action === action) || { action: '-', updatedNameLabel: '-', updatedDateLabel: '-'};
    }
    onTableScroll(event: any) {
        const tableViewHeight = event.target.offsetHeight;
        const tableScrollHeight = event.target.scrollHeight;
        const scrollLocation = event.target.scrollTop;
        const buffer = 200;
        const limit = tableScrollHeight - tableViewHeight - buffer;
        const isLoading = this.commentLoading || this.scrollCommnetLoading;
        if (scrollLocation > limit && !isLoading && this.commentList.length < this.totalItems) {
          this.getCommentListByInvoiceId(true);
        }
    }
    onAddCategorizationItem(): void {
        const index = this.editCategorizationItem.length;
        this.editCategorizationItem.push({
            category: {},
            taxValue: 0,
            amount: 0,
        });
        this.editCategorizationItem = [...this.editCategorizationItem];
        this.filteredCategoriesMap[index] = [...this.cateoryLists];
        this.searchQueries[index] = '';
    }
    onCategoryItemChange(initiallLoading = true): void {
        const { actualCategoryAmount, totalCategoryAmount, totalVatAmount } = this.editCategorizationItem.reduce(
            (acc: {actualCategoryAmount: number, totalCategoryAmount: number, totalVatAmount: number}, item: any) => {
                const amountWithVat = item.amount ? parseFloat(item.amount) : 0;
                const vatMultiplier = 1 + item.taxValue / 100;
                const actualCategoryAmount = amountWithVat / vatMultiplier;
                const vatAmount = amountWithVat - actualCategoryAmount;
                acc.actualCategoryAmount += actualCategoryAmount;
                acc.totalCategoryAmount += amountWithVat;
                acc.totalVatAmount += vatAmount;
                return acc;
                },
            { actualCategoryAmount: 0, totalCategoryAmount: 0 , totalVatAmount: 0}
        );
        this.editInvoiceDetails.totalCategoryAmount = totalCategoryAmount.toFixed(2);
        this.editInvoiceDetails.categoryAmountDifference = (totalCategoryAmount.toFixed(2) - this.editInvoiceDetails.totalAmount);
        this.editInvoiceDetails.vatTotal = totalVatAmount.toFixed(2);
        this.editInvoiceDetails.subTotal = actualCategoryAmount.toFixed(2);
    }
    calculateOutsourceAmount() {
        if (this.linkedTransationLists.length > 0) {
            const totalAmount: any = this.linkedTransationLists.reduce((sum: any, item: any) => {
                return sum + Math.abs(Number(item.amount));
            }, 0);
            this.editInvoiceDetails.outstandingAmount = (Number(this.editInvoiceDetails.totalAmount) - Number(totalAmount));
        } else {
            this.editInvoiceDetails.outstandingAmount = Number(this.editInvoiceDetails.totalAmount);
        }
        
    }
    removeCatergoryItem(index: number): void {
        this.editCategorizationItem.splice(index, 1);
        delete this.filteredCategoriesMap[index];
        delete this.searchQueries[index];
        this.onCategoryItemChange();
        this.filteredCategoriesMap = reindexMap(this.filteredCategoriesMap, this.editCategorizationItem);
        this.searchQueries = reindexMap(this.searchQueries, this.editCategorizationItem);
    }

    getCateroryDetails(name: unknown) {
        return this.rawCategories.find((data: CategoryItem) => data.name == name) || {};
    }

    getCateroryID(data: unknown) {
        return this.rawCategories.find((item: CategoryItem) => item.id === (data as CategoryItem)?.id)?.id ?? null;
    }
    linkTransactionPopup(type: string) {
        let invoiceType = '';
        this.editMode$.subscribe((data) => {
            if (data) {
                invoiceType = (this.editInvoiceDetails.type === 'outbound') ? 'ingoing' : 'outgoing';
            } else {
                invoiceType = (this.selectedInvoice.type === 'outbound') ? 'ingoing' : 'outgoing';
            }
        })
        const dialogRef = this.dialog.open(TransactionAttachmentPopupComponent, {
          data: {
                vehicleId: this.vehicleId,
                invoiceId: this.invoiceId,
                invoiceType: invoiceType,
                gpId: this.entityId
          },
        });
        dialogRef.afterClosed().subscribe((res) => {
            if(res && res == 1) {
                if (type == 'invoice-edit') {
                    this.isLinkedTransaction = true;
                    this.getInvoiceDetailsData();
                } else {
                    this.callApiForInvoiceDetails(false);
                }
            }
        });
      }
    //   invoice details
    getInvoiceDetailsData() {
        this.loadingSubject.next(true);
        this.invoiceDetailService.getInvoiceDetails(this.vehicleId, this.selectedInvoice.id).pipe(
            takeUntil(this.destroy$),
            tap((data: InvoiceDetails) => {
                this.loadingSubject.next(false);
                this.editInvoiceDetails.outstandingAmount = data.outstandingAmount;
                this.linkedTransationLists = data.transactions;
                this.initialLinkedtransactions = data.transactions;
            }),
            catchError((error) => {
                this.loadingSubject.next(false);
                return of(null);
            })
        ).subscribe();
    }
    unLinkInvoiceDailog(type: string, transactiontionId: string) {
        const params: any = {};
        params.transactionIds = [transactiontionId];
        const dialogRef = this.dialog.open(DialogComponent, {
        data: <ModalDialogData>{
            titleKey: 'Are you sure to unlink?',
            contentKey: 'Please confirm if you would like to unlink the linked transaction. You will not be able to undo this action once confirmed.',
            positiveMessageKey: 'Yes',
            negativeMessageKey: 'No',
            isValid: '3',
        },
        disableClose: false,
        });
        dialogRef.afterClosed().subscribe((res) => {
        if(res == 1) {
            this.loadingSubject.next(true);
            this.invoiceDetailService.unlinkInvoiceToTransaction(this.invoiceId, params).pipe(
                takeUntil(this.destroy$),
                tap(() => {
                    this.loadingSubject.next(false);
                    if (type == 'invoice-edit') {
                        this.getInvoiceDetailsData();
                    } else {
                        this.callApiForInvoiceDetails(false);
                    }
                }),
                catchError((error) => {
                    this.loadingSubject.next(false);
                    return of(null);
                })
            ).subscribe();
            }
        });
    }
    showErrorTransaction(outStandingAmount: number | string) {
        return Number(outStandingAmount) < 0;
    }

    clearServiceDate(): void {
        this.editInvoiceDetails.servicePeriodStart = null;
        this.editInvoiceDetails.servicePeriodEnd = null;
    } 

    clearIssueDate(): void {
        this.editInvoiceDetails.issueDate = null;
    }  
    
    clearDueDate(): void {
        this.editInvoiceDetails.dueDate = null;
    }  
    sumOfcategoryAmount() {
        const totalSumOfCategoryAmount = this.invoiceCategorizations.reduce((sum: number, item: InvoiceCategorization) => sum + Number(item.totalAmount), 0);
        const totalAmount = Number(this.selectedInvoice.totalAmount.toFixed(2)) || 0;
        const totalSumOfCategoryAmountRoundOff = Number(totalSumOfCategoryAmount.toFixed(2)) || 0;
        return (totalAmount - totalSumOfCategoryAmountRoundOff);
    }
}